import DOMPurify from 'dompurify';

// Sanitize HTML for the Manual Edit Document feature. Mirrors the backend
// allow-list (utils/sanitizeDocHtml.js) so we strip <script>, on* handlers,
// javascript: URLs, iframes, etc. — while keeping the formatting + inline
// styles the documents need (class, style, data-*).
const ALLOWED_TAGS = [
    'p', 'div', 'span', 'br', 'hr',
    'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
    'strong', 'b', 'em', 'i', 'u', 's', 'sub', 'sup', 'mark', 'small',
    'ul', 'ol', 'li',
    'blockquote', 'pre', 'code',
    'table', 'thead', 'tbody', 'tfoot', 'tr', 'td', 'th', 'caption', 'colgroup', 'col',
    'a', 'img',
    'figure', 'figcaption',
];

const ALLOWED_ATTR = [
    'class', 'style', 'id', 'title', 'lang', 'dir', 'align',
    'href', 'name', 'target', 'rel',
    'src', 'alt', 'width', 'height',
    'colspan', 'rowspan', 'valign', 'scope',
    'span',
    'start', 'type', 'reversed', 'value',
];

const PURIFY_CONFIG = {
    ALLOWED_TAGS,
    ALLOWED_ATTR,
    // Allow data-* attributes
    ALLOW_DATA_ATTR: true,
    // Reject ARIA-related, just in case; doc HTML doesn't need them
    ALLOW_ARIA_ATTR: false,
    // Disallow URIs to javascript:, vbscript:, etc.
    ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|data):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i,
    // Forbid form elements + dangerous tags hard
    FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'form', 'input', 'button', 'select', 'textarea'],
    FORBID_ATTR: [
        'onerror', 'onload', 'onclick', 'onmouseover', 'onmouseout', 'onmousemove',
        'onmousedown', 'onmouseup', 'onfocus', 'onblur', 'onchange', 'oninput',
        'onkeydown', 'onkeyup', 'onkeypress', 'onsubmit', 'onreset', 'ondrag',
        'ondrop', 'onpaste', 'oncopy', 'oncut',
    ],
    // Keep the original DOM order; don't strip text content of removed tags
    KEEP_CONTENT: true,
};

export function sanitizeDocHtml(input) {
    if (typeof input !== 'string') return '';
    return DOMPurify.sanitize(input, PURIFY_CONFIG);
}
